import localStorage from 'localStorage'

export default function clearSession () {

	localStorage.clear()

}
